import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import PropTypes from "prop-types";

const LspCountriesServices = ({
  servicedata,
  isloading,
  limit,
  onChange,
  page,
}) => {
  return (
    <div className="lsp-card h-full mt-4 border-gray">
      <div className="flex justify-content-between formgrid grid grid-nogutter">
        <div className="flex-grow">
          <p className="profile-heading">Countries & Services</p>
        </div>
        {isloading ? (
          <DataTable
            value={Array(6).fill({})}
            tableStyle={{ minWidth: "100%" }}
            className="datatable-right-align w-full pt-2"
            rows={5}
          >
            <Column header="Country" body={<Skeleton />} />
            <Column header="Services Provided" body={<Skeleton />} />
          </DataTable>
        ) : (
          <DataTable
            value={servicedata}
            sortMode="multiple"
            tableStyle={{ minWidth: "50rem" }}
            className="datatable-right-align w-full pt-2"
            emptyMessage="No results were found"
            paginator={servicedata?.length > 10}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            rowsPerPageOptions={[10, 20, 30]}
            first={page}
            rows={limit}
            onPage={onChange}
          >
            <Column
              sortable
              header="Country"
              field="country"
              body={(rowData) => {
                return (
                  <div className="country-tag">
                    <ReactCountryFlag countryCode={rowData.country} svg />
                    <span
                      style={{ textTransform: "capitalize", marginLeft: "7px" }}
                    >
                      {getName(rowData.country)}
                    </span>
                  </div>
                );
              }}
            />
            <Column
              sortable
              field="services"
              header="Services Provided"
              body={(rowData) => {
                const serviceNames = rowData.services
                  .map((service) => service.name)
                  .sort((a, b) =>
                    a.localeCompare(b, "en", { sensitivity: "base" }),
                  );
                return serviceNames.join(", ");
              }}
            />
          </DataTable>
        )}
      </div>
    </div>
  );
};
LspCountriesServices.propTypes = {
  servicedata: PropTypes.object,
  isloading: PropTypes.bool,
  limit: PropTypes.number,
  page: PropTypes.number,
  onChange: PropTypes.func,
};
export default LspCountriesServices;
